import { inject, injectable } from 'inversify';
import type { JwtRefreshGateway } from '@shared/common/network/domain/service/jwt-refresh.gateway';
import { HostDependencyTypes } from '@shared/common/host/host.dependency-types';
import type { CockpitApiService } from '@shared/common/host/data/service/cockpit.api-service';
import type { JwtRefreshApiData } from '@shared/common/host/data/api-data/jwt-refresh.api-data';
import { JwtApiRoute } from '@shared/common/host/data/constant/jwt.api-routes';

@injectable()
export class CockpitJwtRefreshGateway implements JwtRefreshGateway {
  public constructor(
    @inject(HostDependencyTypes.CockpitApiService)
    private readonly cockpitApiService: CockpitApiService,
  ) {}

  public async refresh(): Promise<string> {
    const response = await this.cockpitApiService.post<JwtRefreshApiData, void>(JwtApiRoute.Refresh);

    return response.data.token;
  }
}
